'use strict';

module Patersons {

    export interface HoldingsScope extends ng.IScope {
        accounts: Array<Account>;
        selectedAccount: Account;
        selectedAccountTotals: SelectedAccountTotal;
        events: HoldingsCtrl;
        isLoading: boolean;
        isError: boolean;
        hasData: boolean;
        autoDownloadPDF: boolean;
        autoDownloaded: boolean;
        asAt: Date;

        reverse: boolean;
        predicate: string;
        intReverse: boolean;
        intPredicate: string;
        cashTablePredicate: string;
        cashTableSortOrder: boolean;
        hiReverse: boolean;
        hiPredicate: string;
        termDepositsPredicate: string;
        termDepositsSortOrder: boolean;

        termDepositsReport: TermDepositsHoldingsReport;
        cashHoldingsReport: CashHoldingsReport;
        highInterestCashHoldingsReport: CashHoldingsReport;
        equityHoldingsReport: EquityHoldingsReport;
        internationalHoldingsReport: EquityHoldingsReport;
        totalMarketValue: number;
        valuationReport: ValuationStatement;

        generatedDate: Date;
        timeZoneAEST: string;

        userCompany: UserCompany;

        filter: ng.IFilterService;

    }

    //export class HoldingsCtrl extends AbstractController {
    export class HoldingsCtrl extends PortfolioBaseCtrl {
        q: ng.IQService;
        scope: Patersons.HoldingsScope;
        portfolioService: Patersons.PortfolioService;
        reportService: Patersons.ReportService;
        reportDownloadService: Patersons.ReportDownloadService;
        stateParams: any;
        pdfBuilderService: Patersons.PDFBuilderService;
        selectionService: SelectionService;
        userCompanyService: Patersons.UserCompanyService;

    

        static $inject = ['$scope', '$q', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$filter', 'portfolioService', 'reportService', 'reportDownloadService', 'navigationService', 'selectionService', 'pdfBuilderService','userCompanyService'];

        constructor($scope, $q, $log, $location, $window, $state, $stateParams, $http, $rootScope, $filter, portfolioService, reportService, reportDownloadService, navigationService, selectionService, pdfBuilderService,userCompanyService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.q = $q;
            this.stateParams = $stateParams;
            this.portfolioService = portfolioService;
            this.reportService = reportService;
            this.reportDownloadService = reportDownloadService;
            this.selectionService = selectionService;
            this.scope.accounts = new Array<Account>();
            this.scope.reverse = false;
            this.scope.predicate = "securityCode";
            this.scope.intPredicate = "securityCode";
            this.scope.intReverse = false;
            this.scope.filter = $filter;
            this.scope.asAt = moment().toDate();
            this.pdfBuilderService = pdfBuilderService;
            this.userCompanyService = userCompanyService;

            this.scope.cashTableSortOrder = false;
            this.scope.cashTablePredicate = "instituteCode";
            this.scope.hiPredicate = "instituteCode";
            this.scope.hiReverse = false;
            this.scope.termDepositsSortOrder = false;
            this.scope.termDepositsPredicate = "provider";
            this.scope.hasData = false;
            this.scope.isError = false;

            this.scope.generatedDate = new Date();

            this.userCompanyService.getUserCompany().then((company) => {
                this.scope.userCompany = company;
            })
            if(this.stateParams.accountId){
                this.selectionService.selectedAccountId = $stateParams.accountId;
            }
            if(this.stateParams.asAt){
                this.scope.asAt = moment(this.stateParams.asAt).toDate();
            }
            if(this.stateParams.autoDownloadPDF){
                this.scope.autoDownloadPDF = this.stateParams.autoDownloadPDF;
            }

            this.load();
        }

        checkAutoDownloadPDF(){
            if(this.stateParams && this.stateParams.autoDownloadPDF && !this.scope.autoDownloaded){
                this.downloadPdf()
                this.scope.autoDownloaded = true
            }
        }

        setAsAtDate(selectedDate: Date) {
            console.info('Selected As At Date: ' + selectedDate);
            this.scope.asAt = selectedDate;
        }

        setSelectedAccount(accountId: string) {
            console.info('Selected Account Id: ' + accountId);
            this.scope.hasData = false;
            this.scope.selectedAccount = this.scope.accounts.filter(a => a.accountId == accountId)[0];
        }

        getBackdatedHolding = function () {
            // if(this.scope.isLoading){
            //     return;
            // }
            this.scope.isError = false;
            this.scope.hasData = false;
            let now = moment();
            let selectedDate = moment(this.scope.asAt);
            this.scope.generatedDate = new Date();

            if (selectedDate.isBefore(now, 'day')) {
                this.loadBackdatedHoldings();
            }
            else {
                this.buildReports();
            }
        }

        
        getSummaryText = function () {
            var text = "Report generated at " +
                moment.tz(this.scope.generatedDate, 'Australia/Sydney').format('h:mm a') +
                " AEST on " +
                moment.tz(this.scope.generatedDate, 'Australia/Sydney').format('D MMM YYYY') + ".<br/>" +
                "Australian equity prices are delayed by 20 minutes. International equity prices are from the previous day's close.";
            return text;
        }

        order = function (predicate) {
            this.scope.reverse = (this.scope.predicate === predicate) ? !this.scope.reverse : false;
            this.scope.predicate = predicate;
        };

        orderInternational = function (predicate) {
            this.scope.intReverse = (this.scope.intPredicate === predicate) ? !this.scope.intReverse : false;
            this.scope.intPredicate = predicate;
        };

        orderHiCash = function (predicate) {
            this.scope.hiReverse = (this.scope.hiPredicate === predicate) ? !this.scope.hiReverse : false;
            this.scope.hiPredicate = predicate;
        };

        orderCash = function (predicate) {
            this.scope.cashTableSortOrder = (this.scope.cashTablePredicate === predicate) ? !this.scope.cashTableSortOrder : false;
            this.scope.cashTablePredicate = predicate;
        };

        orderTermDeposits = function (predicate) {
            this.scope.termDepositsSortOrder = (this.scope.termDepositsPredicate === predicate) ? !this.scope.termDepositsSortOrder : false;
            this.scope.termDepositsPredicate = predicate;
        };

        load() {
            this.scope.isLoading = true;
            this.portfolioService.getCombinedPortfolioData()
                .then((result: Account[]) => {
                    this.scope.$apply(() => {
                        this.scope.accounts = result;
                        this.scope.isLoading = false;
                        if((!this.selectionService || !this.selectionService.selectedAccountId) && result[0]){
                            this.setSelectedAccount(result[0].accountId);
                            this.getBackdatedHolding();
                        }
                    });
                })
                .catch((reason) => {
                    this.scope.$apply(() => {
                        this.scope.isLoading = false;
                    });
                });
        }

        loadBackdatedHoldings() {
            if (this.scope.selectedAccount.accountType == "Standard") {
                this.scope.isLoading = true;

                this.portfolioService.getBackdatedPortfolioData(this.scope.selectedAccount.accountId, this.scope.asAt)
                    .then((result) => {
                        this.scope.cashHoldingsReport = new CashHoldingsReport();
                        this.scope.highInterestCashHoldingsReport = new CashHoldingsReport();
                        this.scope.termDepositsReport = new TermDepositsHoldingsReport();

                        let domesticHoldings = result.filter(h => !h.isInternational);
                        this.scope.equityHoldingsReport = this.buildEquityHoldingsReport(domesticHoldings);

                        let internationalHoldings = result.filter(h => h.isInternational);
                        this.scope.internationalHoldingsReport = this.buildInternationalEquityHoldingsReport(internationalHoldings);

                        this.scope.totalMarketValue = this.scope.equityHoldingsReport.total.marketValue + this.scope.internationalHoldingsReport.total.marketValue;
                        this.scope.hasData = true;
                        this.scope.isError = false;
                        this.checkAutoDownloadPDF();
                    },
                    (error) => {
                      this.scope.isError = true;
                      this.scope.hasData = false;
                    }).finally(() => {
                      this.scope.isLoading = false;
                    });
            }
            else {
                this.loadAccoladeAccount();
            }
        }

        downloadPdf() {
            console.info('Download PDF');
            
            let asAtDate = this.scope.asAt;
            let account = this.scope.selectedAccount;
            let fileName = this.getFileName(account.accountId, asAtDate);
            if (this.scope.selectedAccount.accountType == "Standard") {
                this.makeAgilityPdf(account, asAtDate, fileName);
            } else {
                this.makeAccoladePdf(account, fileName,asAtDate);
            }
        }

        downloadCsv() {
            console.info('Download CSV');
            let asAtDate = this.scope.asAt;
            let account = this.scope.selectedAccount;
            let fileName = this.getFileName(account.accountId, asAtDate);

            if (this.scope.selectedAccount.accountType == "Standard") {
                this.makeCsv(account, fileName, asAtDate);
            } else {
                this.reportDownloadService.downloadCsvFile(this.scope.valuationReport, account)
            }
        }

        private makeCsv(account: Account, filename: string, endDate: Date): void {
            filename = filename + ".csv";
            let topLine = ReportDownloadService.getCsvTopLine(account, new Date(), endDate, endDate, undefined);
            let csvBuilder = new CsvBuilder();

            let cashHoldings = this.scope.cashHoldingsReport;
            let highInterestCashHoldings = this.scope.highInterestCashHoldingsReport;
            let termDeposits = this.scope.termDepositsReport;
            let equityHoldings = this.scope.equityHoldingsReport;
            let internationalHoldings = this.scope.internationalHoldingsReport;
            let pricesQuotedAt = this.scope.selectedAccount.pricesQuotedAt;
            let totalMarketValue = this.scope.totalMarketValue;

            let formattedTermDeposits = this.getFormattedTermDeposits(termDeposits);
            let formattedCashHoldings = this.getFormattedCashHoldings(cashHoldings);
            let formattedHighInterestCashHoldings = this.getFormattedCashHoldings(highInterestCashHoldings);
            let formattedEquityHoldings = this.getFormattedHoldings(equityHoldings);
            let formattedInternationalHoldings = this.getFormattedHoldingsInternational(internationalHoldings);
            let allCSVData = [];


            // Term Deposits.
            if (formattedTermDeposits && formattedTermDeposits.length > 0) {
                allCSVData.push(this.getRowHeading("Term Deposits"));
                allCSVData.push([
                  "MATURITY DATE",
                  "INSTITUTION",
                  "BALANCE",
                  "RATE",
                ]);
                formattedTermDeposits.forEach(x => {
                    const data = [
                        (x.maturityDate) ? x.maturityDate : "",
                        (x.provider) ? x.provider : "",
                        (x.balance) ? x.balance : "",
                        (x.rate) ? x.rate : "",
                    ]
                    allCSVData.push(data);
                });
            }

            // Cash Accounts.
            if (formattedCashHoldings && formattedCashHoldings.length > 0) {
                allCSVData.push(this.getRowHeading("Cash Accounts"));
                allCSVData.push([
                  "INSTITUTION",
                  "ACCOUNT NAME",
                  "BALANCE",
                  "TYPE",
                ]);
                formattedCashHoldings.forEach(x => {
                    const data = [
                        (x.instituteCode) ? x.instituteCode : "",
                        (x.accountName) ? x.accountName : "",
                        (x.balance) ? x.balance : "",
                        (x.type) ? x.type : "",
                    ]
                    allCSVData.push(data);
                });
            }

            // High Interest Cash Holdings
            if (formattedHighInterestCashHoldings && formattedHighInterestCashHoldings.length > 0) {
                allCSVData.push(this.getRowHeading("High Interest Cash Accounts"));
                allCSVData.push([
                  "INSTITUTION",
                  "ACCOUNT NAME",
                  "BALANCE",
                  "RATE",
                ]);

                formattedHighInterestCashHoldings.forEach(x => {
                    const data = [
                        (x.instituteCode) ? x.instituteCode : "",
                        (x.accountName) ? x.accountName : "",
                        (x.balance) ? x.balance : "",
                        (x.interestRate) ? x.interestRate : "",
                    ]
                    allCSVData.push(data);
                });
            }

            // Australian Equities.
            if (formattedEquityHoldings && formattedEquityHoldings.length > 0) {
                allCSVData.push(this.getRowHeading("Australian Equities"));
                allCSVData.push([
                  "CODE",
                  "NAME",
                  "QUANTITY",
                  "AVERAGE COST",
                  "MARKET PRICE",
                  "TOTAL COST",
                  "MARKET VALUE",
                  "PROFIT (LOSS)",
                  "Historic DPS **",
                  "Historic Fr. Credits",
                  "Historic Est. Income",
                  "Historic YIELD",
                ]);

                formattedEquityHoldings.forEach(x => {

                    const data = [
                        (x.securityCode) ? x.securityCode : "",
                        (x.companyName) ? x.companyName : "",
                        (x.quantity) ? x.quantity : "",
                        (x.averageCost) ? x.averageCost : "",
                        (x.lastPrice) ? x.lastPrice : "",
                        (x.totalCost) ? x.totalCost : "",
                        (x.marketValue) ? x.marketValue : "",
                        (x.profitOrLoss) ? x.profitOrLoss : "",
                        (x.dividendPerShare) ? x.dividendPerShare : "",
                        (x.frankedAmount) ? x.frankedAmount : "",
                        (x.income) ? x.income : "",
                        (x.yield) ? x.yield : "",
                    ]
                    allCSVData.push(data);

                });
            }
            const internationalFields = this.getFieldsInternational()
            // International Holdings.
            if (formattedInternationalHoldings && formattedInternationalHoldings.length > 0) {
                allCSVData.push(this.getRowHeading("International Equities"));
                allCSVData.push([
                    "CODE",
                    "CURRENCY",
                    "NAME",
                    "QUANTITY", 
                    "NATIVE COST PRICE", 
                    "NATIVE TOTAL COST", 
                    "NATIVE MARKET PRICE", 
                    "NATIVE MARKET VALUE", 
                    "NATIVE PROFIT (LOSS)", 
                    "AUD MARKET VALUE", 
                ]);

                formattedInternationalHoldings.forEach(x => {
                    const data = [
                        (x.securityCode) ? x.securityCode : "",
                        (x.currency) ? x.currency : "",
                        (x.companyName) ? x.companyName : "",
                        (x.quantity) ? x.quantity : "" ,
                        (x.nativeCostPrice) ? x.nativeCostPrice : "" ,
                        (x.nativeTotalCost) ? x.nativeTotalCost : "" ,
                        (x.nativeMarketPrice) ? x.nativeMarketPrice : "" ,
                        (x.nativeMarketValue) ? x.nativeMarketValue : "" ,
                        (x.nativeProfitLoss) ? x.nativeProfitLoss : "" ,
                        (x.marketValue) ? x.marketValue : "" ,
                    ];
                    allCSVData.push(data);
                });
            }

            // Grand Total
            allCSVData.push([
                "Grand Total",
                "",
                "",
                "",
                "",
                totalMarketValue,
            ]);

            csvBuilder.setFilename(filename)
                .setTopLine(topLine)
                .setHeaders(this.getHeadings())
                .setData(allCSVData)
                .build();
        }

        private getRowHeading(title: string) {
            return [title]
        }


        private getHeadings(): string[] {
            return [];
        }

        private getAccoladeHeadings(): string[] {
            return [];
        }

        private getFileName(accountId: string, asAtDate: Date): string {
            var asAtDateStr = moment(asAtDate).format("YYYY-MM-DD");
            return accountId + "-Holdings-" + asAtDateStr;
        }

        private makeAccoladePdf(account: Account, filename: string,asAtDate: Date): any {
            let reportData: ValuationStatement = this.scope.valuationReport;
            let asAt: string =  moment(asAtDate).format("D MMM YYYY");
            let generatedAt: string = moment.tz(reportData.creationDateUtc, 'Australia/Sydney').format('h:mm a [AEST on] D MMM YYYY');
            let pricesQuotedAt: string = moment.tz(this.scope.selectedAccount.pricesQuotedAt, 'Australia/Sydney').format('h:mm a [AEST on] D MMM YYYY');

            this.reportDownloadService.report = reportData;
            // Build a valuation statement (aka Accolade Holdings) PDF document definition using an empty content object.
            // We'll inject this document definition into our PDF builder in the next step.
            let docDefinition = this.reportDownloadService.getValuationStatement({ content: [] });
            this.pdfBuilderService.newPdfBuilderInstance().then((pdfBuilder) => {
                pdfBuilder
                    .setTitle(reportData.title)
                    .setSubTitle(this.scope.filter<any>("accountName")(account.designation ? account.accountName+' '+account.designation : account.accountName))
                    .addHeaderTableRow('Adviser:',account.adviserName, '','')
                    .addHeaderTableRow('Account:',account.accountId, '','')
                    .addHeaderTableRow('Report Generated At:', generatedAt, 'As at:', asAt)
                    .addHeading(this.getStandardDisclaimer())
                    .setFilename(filename)
                    .build(docDefinition.content);
            })
        }

        private makeAgilityPdf(account: Account, asAtDate: Date, filename: string): any {
            let nowDate = moment(new Date());
            let asAtDateStr = moment(asAtDate).format("D MMM YYYY");
            let cashHoldings = this.scope.cashHoldingsReport;
            let highInterestCashHoldings = this.scope.highInterestCashHoldingsReport;
            let termDeposits = this.scope.termDepositsReport;
            let equityHoldings = this.scope.equityHoldingsReport;
            let internationalHoldings = this.scope.internationalHoldingsReport;
            let pricesQuotedAt = this.scope.selectedAccount.pricesQuotedAt;
            let totalMarketValue = this.scope.totalMarketValue;

            let formattedTermDeposits = this.getFormattedTermDeposits(termDeposits);
            let formattedCashHoldings = this.getFormattedCashHoldings(cashHoldings);
            let formattedHighInterestCashHoldings = this.getFormattedCashHoldings(highInterestCashHoldings);
            let formattedEquityHoldings = this.getFormattedHoldings(equityHoldings);
            let formattedInternationalHoldings = this.getFormattedHoldingsInternational(internationalHoldings);

            let lastRowIsTotal: boolean = true;
            this.pdfBuilderService.newPdfBuilderInstance().then((pdfBuilder) => {
                pdfBuilder
                    .setTitle('Holdings')
                    .setSubTitle(this.scope.filter<any>("accountName")(account.designation ? account.accountName+' '+account.designation : account.accountName))
                    .addHeaderTableRow('Adviser:',account.adviserName, '','')
                    .addHeaderTableRow('Account:',account.accountId, '','')
                    .addHeaderTableRow('Report Generated At:', moment.tz(nowDate, 'Australia/Sydney').format('h:mm a [AEST on] D MMM YYYY'), 'As at:', asAtDateStr)
                    .addHeading(this.getStandardDisclaimer())
                    .addTableAligned(
                      'Australian Equities',
                      formattedEquityHoldings,
                      this.getHoldingsFields(),
                      this.getHoldingsHeadingsAligned(),
                      this.getHoldingsFormatHints(),
                      lastRowIsTotal)
                    .addTableAligned(
                      'International Equities',
                      formattedInternationalHoldings,
                      this.getInternationalHoldingsFields(),
                      this.getInternationalHoldingsHeadingsAligned(),
                      this.getInternationalHoldingsFormatHints(),
                      lastRowIsTotal)
                    .addTable(
                      'Cash Accounts',
                      formattedCashHoldings,
                      this.getCashHoldingsFields(),
                      this.getCashHoldingsHeadings(),
                      this.getCashHoldingsFormatHints(),
                      lastRowIsTotal)
                    .addTable(
                      'High Interest Cash Accounts',
                      formattedHighInterestCashHoldings,
                      this.getCashHoldingsFields(),
                      this.getCashHoldingsHeadings(),
                      this.getCashHoldingsFormatHints(),
                      lastRowIsTotal)
                    .addTable(
                      'Term Deposits',
                      formattedTermDeposits,
                      this.getTermDepositsFields(),
                      this.getTermDepositsHeadings(),
                      this.getTermDepositsFormatHints(),
                      lastRowIsTotal)
                    .addTable(
                      'Grand Total',
                      [{ total: totalMarketValue }],
                      ['total'],
                      null,//['Total Market Value'],
                      [PdfFormatHint.Currency],
                      false)
                    .setFilename(filename)
                    .build();
            })
        }

        private getFormattedTermDeposits(data: TermDepositsHoldingsReport) {
            if (!data || !data.holdings) {
                return null;
            }
            var formattedData: TermDeposit[] = angular.copy(data.holdings);
            if (data.total && data.total.hasData()) {
                formattedData.push(angular.copy(data.total));
            }
            formattedData = formattedData.map<any>((record) => {
                return {
                    maturityDate: moment(record.maturityDate).format("DD/MM/YYYY"),
                    provider: record.provider,
                    balance: record.balance,
                    rate: record.rate
                };
            });
            return formattedData;
        }

        private getFormattedCashHoldings(data: CashHoldingsReport) {
            if (!data || !data.holdings) {
                return null;
            }
            var formattedData: CashHolding[] = angular.copy(data.holdings);
            if (data.total && data.total.hasData()) {
                formattedData.push(angular.copy(data.total));
            }
            formattedData = formattedData.map<any>((record) => {
                return {
                    instituteCode: record.instituteCode,
                    accountName: record.accountName,
                    balance: record.balance,
                    type: record.type
                };
            });
            return formattedData;
        }

        private getFieldsInternational() {
            return [
                "securityCode",
                "currency",
                "companyName",
                "quantity", 
                "nativeCostPrice", 
                "nativeTotalCost", 
                "nativeMarketPrice", 
                "nativeMarketValue", 
                "nativeProfitLoss", 
                "totalCost", 
                "marketValue", 
                "profitOrLoss", 
            ];
        }
        private getFields() {
            return [
              "securityCode",
              "companyName",
              "quantity",
              "averageCost",
              "lastPrice",
              "totalCost",
              "marketValue",
              "profitOrLoss",
              "dividendPerShare",
              "frankedAmount",
              "income",
              "yield"//,
              //"priceToEarnings"
            ];
        }

        private getAccoladeFields() {
            const result = [];
            if(this.scope.userCompany.enableFeature){
                const result = [
                    "code",
                    "securityName",
                    "quantity",
                    "costPrice",
                    "reducedCostBase",
                    "marketPrice",
                    "marketValue",
                    "profitOrLoss",
                    "pctAssets",
                    "estIncome",
                    "estFrankingCredits",
                    "estGrossYield"
                ];
                return result;
            }else{
                const result = [
                    "code",
                    "securityName",
                    "quantity",
                    "costPrice",
                    "reducedCostBase",
                    "marketPrice",
                    "marketValue",
                    "profitOrLoss",
                    "pctAssets",
                ];
                return result;
            }
            
        }

        private getFormattedHoldingsInternational(data: EquityHoldingsReport) {
            if (!data || !data.holdings) {
                return null;
            }
            var formattedData: EquityHolding[] = angular.copy(data.holdings);
            if (data.total && data.total.hasData()) {
                formattedData.push(angular.copy(data.total));
            }
            formattedData = formattedData.map<any>((record) => {
                return {
                    securityCode: record.securityCode,
                    currency: record.currency,
                    companyName: record.companyName,
                    quantity: record.quantity, 
                    nativeCostPrice: record.nativeCostPrice, 
                    nativeTotalCost: record.nativeTotalCost, 
                    nativeMarketPrice: record.nativeMarketPrice, 
                    nativeMarketValue: record.nativeMarketValue, 
                    nativeProfitLoss: record.nativeProfitLoss, 
                    totalCost: record.totalCost, 
                    marketValue: record.marketValue, 
                    profitOrLoss: record.profitOrLoss, 

                };
            });
            return formattedData;
        }
        private getFormattedHoldings(data: EquityHoldingsReport) {
            if (!data || !data.holdings) {
                return null;
            }
            var formattedData: EquityHolding[] = angular.copy(data.holdings);
            if (data.total && data.total.hasData()) {
                formattedData.push(angular.copy(data.total));
            }
            formattedData = formattedData.map<any>((record) => {
                return {
                    securityCode: record.securityCode,
                    companyName: record.companyName,
                    quantity: record.quantity,
                    averageCost: record.averageCost,
                    lastPrice: record.lastPrice,
                    totalCost: record.totalCost,
                    marketValue: record.marketValue,
                    profitOrLoss: record.profitOrLoss,
                    dividendPerShare: record.dividendPerShare,
                    frankedAmount: record.frankedAmount,
                    income: record.income,
                    "yield": record.yield,
                    //priceToEarnings: record.priceToEarnings
                };
            });
            return formattedData;
        }
        private getTermDepositsFields() {
            return ["maturityDate", "provider", "balance", "rate"];
        }

        private getCashHoldingsFields() {
            return ["instituteCode", "accountName", "balance", "type"];
        }
        private getInternationalHoldingsFields() {
            return [
                "securityCode",
                "currency",
                "companyName",
                "quantity", 
                "nativeCostPrice", 
                "nativeTotalCost", 
                "nativeMarketPrice", 
                "nativeMarketValue", 
                "nativeProfitLoss", 
                "marketValue", 
            ];
        }
        private getHoldingsFields() {
            return ["securityCode",
                "companyName",
                "quantity",
                "averageCost",
                "lastPrice",
                "totalCost",
                "marketValue",
                "profitOrLoss",
                "dividendPerShare",
                "frankedAmount",
                "income",
                "yield",
              /*"priceToEarnings"*/];
        }

        private getTermDepositsFormatHints() {
            return [
                PdfFormatHint.None,
                PdfFormatHint.None,
                PdfFormatHint.Currency,
                PdfFormatHint.None
            ];
        }
        private getCashHoldingsFormatHints() {
            return [
                PdfFormatHint.None,
                PdfFormatHint.None,
                PdfFormatHint.Currency,
                PdfFormatHint.None
            ];
        } 
        private getInternationalHoldingsFormatHints() {
            return [
                PdfFormatHint.None,
                PdfFormatHint.None,
                PdfFormatHint.None,
                PdfFormatHint.None,
                PdfFormatHint.Currency4decPts,
                PdfFormatHint.Currency,
                PdfFormatHint.Currency4decPts,
                PdfFormatHint.Currency,
                PdfFormatHint.Currency,
                PdfFormatHint.Currency,
                PdfFormatHint.Currency,
            ];
        }

        private getHoldingsFormatHints() {
            return [
                PdfFormatHint.None,
                PdfFormatHint.None,
                PdfFormatHint.None,
                PdfFormatHint.Currency4decPts,
                PdfFormatHint.Currency4decPts,
                PdfFormatHint.Currency,
                PdfFormatHint.Currency,
                PdfFormatHint.Currency,
                PdfFormatHint.Currency,
                PdfFormatHint.Currency,
                PdfFormatHint.Currency,
                PdfFormatHint.Currency
            ];
        }

        private getTermDepositsHeadings(): string[] {
            return ["Maturity Date", "Institution", "Balance", "Rate"];
        }

        private getCashHoldingsHeadings(): string[] {
            return ["Institution", "Account Name", "Balance", "Type"];
        }

        private getHoldingsHeadings(): string[] {
            return ["Code", "Name", "Quantity", "Average Cost",
                "Market Price", "Total Cost", "Market Value",
                "Profit (Loss)", "Historic DPS**", "Historic Fr. Credits", "Historic Est. Income",
                "Yield", /*"PE"*/];
        }

        private getInternationalHoldingsHeadingsAligned(): any[] {
            return [
                {text: "Code" ,type: "string"},
                {text: "Currency" ,type: "string"},
                {text: "Name" ,type: "string"},
                {text: "Quantity" ,type: "number"}, 
                {text: "Native Cost Price" ,type: "number"}, 
                {text: "Native Total Cost" ,type: "number"}, 
                {text: "Native Market Price" ,type: "number"}, 
                {text: "Native Market Value" ,type: "number"}, 
                {text: "Native Profit (Loss)" ,type: "number"}, 
                {text: "AUD Market Value" ,type: "number"}, 
            ];
        }
        private getHoldingsHeadingsAligned(): any[] {
            return [
              {text: "Code", type: "string"},
              {text: "Name",  type: "string"},
              {text: "Quantity",  type: "number"},
              {text: "Average Cost", type: "number"},
              {text: "Market Price",  type: "number"},
              {text: "Total Cost",  type: "number"},
              {text: "Market Value", type: "number"},
              {text: "Profit (Loss)",  type: "number"},
              {text: "Historic DPS**",  type: "number"},
              {text: "Historic Fr. Credits",  type: "number"},
              {text: "Historic Est. Income", type: "number"},
              {text: "Historic Yield",  type: "number"},
            /*{text: "PE", type: "number"},*/ ];
        }

        getStandardDisclaimer() {
            return '* Australian Equity prices are delayed by 20 mins. International equity prices are the previous day\'s closing price.';
        }

        buildReports() {
            if (this.scope.selectedAccount == undefined) {
                return;
            }

            this.scope.isLoading = true;

            if (this.scope.selectedAccount.accountType == "Standard") {
                this.loadStandardAccount();
            }
            else {
                this.loadAccoladeAccount()
            }
        }

        loadStandardAccount() {
            let cashAccountsPromise = this.portfolioService.getCashAccounts(this.scope.selectedAccount.accountId);
            cashAccountsPromise.then((result) => {
              this.scope.selectedAccount.cashDeposits = result;
              this.scope.cashHoldingsReport = this.buildCashHoldingReport(result);
            }, (error) => { // error handling
              this.scope.selectedAccount.cashDeposits = null;
              this.scope.cashHoldingsReport = null;
            });

            let highInterestCashPromise = this.portfolioService.getHighInterestCashAccounts(this.scope.selectedAccount.accountId);
            highInterestCashPromise.then((result) => {
                this.scope.highInterestCashHoldingsReport = this.buildCashHoldingReport(result);
            }, (error) => { // error handling
              this.scope.highInterestCashHoldingsReport = null;
            });

            let termDepositPromise = this.portfolioService.getTermDeposits(this.scope.selectedAccount.accountId);
            termDepositPromise.then((result) => {
                this.scope.selectedAccount.termDeposits = result;
                this.scope.termDepositsReport = this.buildTermDepositsReport(this.scope.selectedAccount);
            }, (error) => { // error handling
              this.scope.selectedAccount.termDeposits = null;
              this.scope.termDepositsReport = null;
            });

            let internationalSharesPromise = this.portfolioService.getInternationalSharesForHoldings(this.scope.selectedAccount);
            internationalSharesPromise.then((result) => {
                this.scope.internationalHoldingsReport = this.buildInternationalEquityHoldingsReport(result);
            }, (error) => { // error handling
              this.scope.internationalHoldingsReport = null;
            });

            let sharesPromise = this.portfolioService.getShares(this.scope.selectedAccount.accountId);
            sharesPromise.then((result) => {
                this.scope.selectedAccount.holdings = result;
                this.scope.equityHoldingsReport = this.buildEquityHoldingsReport(this.scope.selectedAccount.holdings);
                if (this.scope.selectedAccount.holdings[0]) {
                    this.scope.selectedAccount.pricesQuotedAt = this.scope.selectedAccount.holdings[0].asOf;
                }
            }, (error) => { // error handling
              this.scope.selectedAccount.holdings = null;
              this.scope.equityHoldingsReport = null;
            });

            
            let allPromises = this.q.all([
              cashAccountsPromise,
              highInterestCashPromise,
              termDepositPromise,
              internationalSharesPromise,
              sharesPromise]);
            allPromises.then(() => {
                this.scope.totalMarketValue = this.scope.equityHoldingsReport.total.marketValue + this.scope.internationalHoldingsReport.total.marketValue + this.scope.cashHoldingsReport.total.balance + this.scope.termDepositsReport.total.balance;
            }, (error) => { // error handling
              this.scope.totalMarketValue = null;
            });
            allPromises.finally(() => {
                this.scope.isLoading = false;
                this.scope.hasData = true;
                this.checkAutoDownloadPDF();
            });
        }

        loadAccoladeAccount() {
            this.scope.isLoading = true;
            this.reportService.getReport(ReportType.Valuation, this.scope.selectedAccount.accountId, this.scope.asAt, this.scope.asAt)
                .then((result) => {
                    this.scope.selectedAccount.pricesQuotedAt = this.scope.asAt;
                    this.scope.valuationReport = result as ValuationStatement;
                    this.scope.hasData = true;
                    this.scope.isError = false;
                    this.checkAutoDownloadPDF();
                },
                (error) => {
                  // error handling
                  this.scope.selectedAccount.pricesQuotedAt = this.scope.asAt;
                  this.scope.valuationReport = null;
                  this.scope.isError = true;
                  this.scope.hasData = false;
                }).finally(() => {
                    this.scope.isLoading = false;
                });
        }

        buildCashHoldingReport(cashDeposits: CashDeposit[]) {

            var report = new CashHoldingsReport();
            var holdings = new Array<CashHolding>();
            var total = new CashHolding();

            total.balance = 0;

            for (var i = 0; i < cashDeposits.length; i++) {
                var cashDeposit = cashDeposits[i];
                var rec = new CashHolding();

                rec.instituteCode = cashDeposit.instituteCode;
                rec.accountName = cashDeposit.accountName;
                rec.balance = cashDeposit.balance;
                rec.type = cashDeposit.type;
                rec.interestRate = cashDeposit.interestRate

                holdings.push(rec);

                total.balance += cashDeposit.balance;
            }

            report.holdings = holdings;
            report.total = total;
            return report;
        }

        buildEquityHoldingsReport(inputHoldings: Holding[]) {
            var report = new EquityHoldingsReport();
            var holdings = new Array<EquityHolding>();
            var total = new EquityHolding();


            total.totalCost = 0;
            total.marketValue = 0;
            total.profitOrLoss = 0;
            total.income = 0;

            for (var i = 0; i < inputHoldings.length; i++) {
                var holding = inputHoldings[i];

                if (!holding.isInternational) {
                    var rec = new EquityHolding();
                    rec.exchange = holding.exchange;
                    rec.securityCode = holding.securityCode;
                    rec.companyName = holding.companyName;
                    rec.quantity = holding.quantity;
                    rec.averageCost = holding.averageCost;
                    rec.lastPrice = holding.lastPrice;
                    rec.totalCost = holding.totalCost;
                    rec.marketValue = holding.marketValue;
                    rec.profitOrLoss = holding.profitOrLoss;
                    rec.dividendPerShare = holding.dividendPerShare;
                    rec.frankedAmount = holding.frankedAmount;
                    rec.income = holding.income;
                    rec.yield = holding.yield;
                    //rec.priceToEarnings = holding.priceToEarnings;

                    holdings.push(rec);

                    total.totalCost += holding.totalCost;
                    total.marketValue += holding.marketValue;
                    total.profitOrLoss += holding.profitOrLoss;
                    total.income += holding.income;
                }
            }

            report.holdings = holdings;
            report.total = total;

            return report;
        }

        buildInternationalEquityHoldingsReport(intHoldings: Holding[]) {
            var report = new EquityHoldingsReport();
            var holdings = new Array<EquityHolding>();
            var total = new EquityHolding();


            total.totalCost = 0;
            total.marketValue = 0;
            total.profitOrLoss = 0;
            total.income = 0;
            total.nativeTotalCost = 0;
            total.nativeMarketValue = 0;
            total.nativeProfitLoss = 0;

            for (var i = 0; i < intHoldings.length; i++) {
                var holding = intHoldings[i];

                var rec = new EquityHolding();
                rec.exchange = holding.exchange;
                rec.securityCode = holding.securityCode;
                rec.companyName = holding.companyName;
                rec.quantity = holding.quantity;
                rec.averageCost = holding.averageCost;
                rec.lastPrice = holding.lastPrice;
                rec.totalCost = holding.totalCost;
                rec.marketValue = holding.marketValue;
                rec.profitOrLoss = holding.profitOrLoss;
                rec.dividendPerShare = holding.dividendPerShare;
                rec.frankedAmount = holding.frankedAmount;
                rec.income = holding.income;
                rec.yield = holding.yield;

                rec.currency = holding.currency;
                rec.nativeCostPrice = holding.nativeCostPrice;
                rec.nativeTotalCost = holding.nativeTotalCost;
                rec.nativeMarketPrice = holding.nativeMarketPrice;
                rec.nativeMarketValue = holding.nativeMarketValue;
                rec.nativeProfitLoss = holding.nativeProfitLoss;
                //rec.priceToEarnings = holding.priceToEarnings;

                holdings.push(rec);

                total.totalCost += holding.totalCost;
                total.nativeTotalCost += holding.nativeTotalCost;
                total.nativeMarketValue += holding.nativeMarketValue;
                total.nativeProfitLoss += holding.nativeProfitLoss;
                total.marketValue += holding.marketValue;
                total.profitOrLoss += holding.profitOrLoss;
                total.income += holding.income;

            }

            report.holdings = holdings;
            report.total = total;

            return report;
        }

        buildTermDepositsReport(account: Account) {

            var report = new TermDepositsHoldingsReport();
            var holdings = new Array<TermDeposit>();
            var total = new TermDeposit();

            total.balance = 0;

            for (var i = 0; i < account.termDeposits.length; i++) {
                var termDeposit = account.termDeposits[i];
                var rec = new TermDeposit();

                rec.accountCode = termDeposit.accountCode;
                rec.balance = termDeposit.balance;
                rec.maturityDate = termDeposit.maturityDate;
                rec.provider = termDeposit.provider;
                rec.rate = termDeposit.rate;

                holdings.push(rec);

                total.balance += termDeposit.balance;
            }

            report.holdings = holdings;
            report.total = total;
            return report;
        }
    }
}
